import { summaryService } from '../../helpers/services/reportDetailSummary.service';
import { sharedHelper, filtersHelper } from '@/utils'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const REPORT_DETAIL_SUMMARY_MODULE = 'reportDetailSummary'; 

// define action 
export const GET_BY_REPORT_ID = 'getByReportID';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_SUMMARY_REQUEST = "getAllSummary";

export const actions = {

    async [GET_BY_REPORT_ID]({ commit }, { id }) {
       await summaryService
            .getByReportID(id)
            .then(
                (result) => {
                    commit(GET_ALL_SUMMARY_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },
};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        // router.push({ name: "Report-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = {processing: true};
    },
    [GET_ALL_SUMMARY_REQUEST](state, data) {
        let d = data.data

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                quantity: o.quantity,
                newReport: o.new_report,
                package: o.package,
                service: o.service,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
                updatedBy: o.updated_by,
                updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
            }
        })
    },
}


